

import CookiesEuBanner from "cookies-eu-banner";
import Splide from "@splidejs/splide";
import LazyLoad from "vanilla-lazyload";
import { main } from '../assets/scripts/main.js';


new CookiesEuBanner(function () {
    console.log('Cookies Enabled');
    console.log('Google Analytics Enabled');
    console.log('Google Tag Manager Enabled');

    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-WQRSSVX');
    
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'UA-177506867-1');
  
}, true);


var elms = document.getElementsByClassName( 'splide' );
for ( var i = 0, len = elms.length; i < len; i++ ) {
	new Splide( elms[ i ], {
        type: 'loop', // Slide, Loop, Fade
        speed: 600,
        heightRatio: 0.6,   
        autoplay: true,
        interval: 12000,
        pauseOnHover: false,
        pauseOnFocus: false,
        resetProgress: false,
        lazyLoad: 'nearby',
        direction: 'ltr',
        height: '100vh',
        width: '100vw',
        autoHeight: true,
        passive: true,
        padding: 0,
        gap: 0,
        perPage: 1,
        arrows : false,
    } ).mount();
}

var myLazyLoad = new LazyLoad(); 
myLazyLoad.update();

let val = main();



